module.exports = __webpack_public_path__ + "img/syukyaku-kyu-back001.8b13f480.jpg";